import { format } from "date-fns";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Button, Col, Container, Form, InputGroup, Row, Spinner } from "react-bootstrap";
import { zeroPad } from "react-countdown";
import CurrencyInput from "react-currency-input-field";
import toast from "react-hot-toast";
import { showBidErrorToast } from "../../utils/bidToast";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import "../../assets/css/component.css";
import Coupon from "../../assets/icons/Coupon";
import Location from "../../assets/icons/Location";
import SpecialNIPL from "../../assets/icons/SpecialNIPL";
import Time from "../../assets/icons/Time";
import Warning from "../../assets/icons/Warning";
import LockOff from "../../assets/icons/lock_off";
import LockOn from "../../assets/icons/lock_on";
import imageCar from "../../assets/images/category-car.png";
import CardUnit from "../../components/CardUnit/CardUnit";
import ConnectionLatency from "../../components/ConnectionLatency/ConnectionLatency";
import CancelledProxy from "../../components/Modals/CancelledProxy";
import KonfirmasiMenangLelang from "../../components/Modals/KonfirmasiMenangLelang";
import ResultLelang from "../../components/Modals/ResultLelang";
import OnlineAuctionSkeleton from "../../components/Skeleton/OnlineAuctionSkeleton";
import CarouselLayout from "../../containers/Layouts/CarouselLayout/CarouselLayout";
import CarouselMultipleLayout from "../../containers/Layouts/CarouselLayout/CarouselMultipleLayout";
import { userSelector } from "../../redux/auth.slice";
import { actionsLiveAuction } from "../../redux/liveAuction.slice";
import withAuth from "../../services/withAuthProvider";
import PageNotFound from "../Errors/PageNotFound";
import ArtworkPending from "./ArtworkPending";
import { isDate } from "../../utils/string";

import * as io from "socket.io-client";
import { ProxyBidIcon, TimerIcon } from "../../assets/icons/AuctionIcons";
import UserIcon from "../../assets/icons/UserIcon";
import NoImage from "../../assets/images/NoImage.jpg";

// Import color constants for better maintainability
import {
  textDark,
  textWhite,
  danger,
  socketConnected,
  socketReconnecting,
  socketDisconnected,
  socketError,
  socketUnknown,
  bidDisabledInactive,
  bidDisabledActive,
} from "../../config/colors";
import moment from "moment";

const defaultImage = NoImage;
const initialBid = {
  buyer: {},
  offer_price: 0,
  type: "-",
};

const initialDataModal = {
  lot_number: "",
  data_unit: {},
};

// Sama dengan pesan server (backend MsgBidLostRace)
const slowerBidder = "Anda Kalah Cepat!";
const niplOutOfStock = "NIPL anda telah habis";
const errorSendBidMessages = [
  slowerBidder,
  "NIPL anda telah habis",
  "Tidak Bisa Bid, kamu Sekarang Bidder Tertinggi!",
];

// Lazy Load Component for Lot Cards
const LazyLotCard = ({ item, auction, processUnitDetails }) => {
  const cardRef = useRef(null);
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    const currentRef = cardRef.current;
    if (!currentRef) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !shouldRender) {
            setShouldRender(true);
          }
        });
      },
      {
        root: null,
        rootMargin: "200px",
        threshold: 0.01,
      }
    );

    observer.observe(currentRef);

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [shouldRender]);

  const unitDetail = useMemo(() => {
    if (!shouldRender) return null;
    return processUnitDetails(item);
  }, [shouldRender, item, processUnitDetails]);

  return (
    <div ref={cardRef} style={{ padding: "0 8px" }}>
      {shouldRender ? (
        <CardUnit
          link={
            item?.auction?.is_exclusive
              ? `https://${item?.auction?.exclusive_seller_slug}.${window.location.hostname}/unit-lelang/${item.id}`
              : `/unit-lelang/${item.id}`
          }
          timeLocation={true}
          lot_number={`${auction?.auction_lane_name}${item?.lot_number}` || "-"}
          price={item?.base_price}
          tags={item?.tags || []}
          nama={item?.unit_name}
          location={item?.auction?.location_name}
          auction={item?.auction}
          pictures={item?.pictures}
          grade={item?.unit_inspection?.grade}
          unitType={item?.unit_type?.name}
          unitDetail={unitDetail}
          specialNIPL={item?.number_of_nipl}
        />
      ) : (
        <div
          style={{
            minHeight: "350px",
            backgroundColor: "#f8f9fa",
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Spinner animation="border" size="sm" variant="secondary" />
        </div>
      )}
    </div>
  );
};

export default function LiveAuctionGo() {
  // const currentDataUnit = useSelector(currentdataUnitSelector);
  const thisUser = useSelector(userSelector);
  const [SpecialNIPLToggle, setSpecialNIPLToggle] = useState({
    remaining_nipls: 0,
    used_nipls_this_stock_unit: 0,
    is_special_nipl: "false",
    number_of_nipl: 0,
  });

  const { id } = useParams();
  const { push } = useHistory();
  const dispatch = useDispatch();

  const [isOpen, setIsOpen] = useState(false);
  const [result, setResult] = useState("LOADING");
  const [key, setKey] = useState(1);
  const [color, setColor] = useState("success");
  const [dataModal, setDataModal] = useState({ ...initialDataModal });
  const [totalNipl, setTotalNipl] = useState(0);

  // status
  const [disableBid, setDisabledBid] = useState("off");
  const [blockBid, setBlockBid] = useState("off");
  const [isProcess, setIsProcess] = useState("off");
  const [liveAuction, setLiveAuction] = useState("COMING");
  const [modalResult, setModalResult] = useState(false);
  const [isSelectingWinner, setIsSelectingWinner] = useState(false);
  const [showNextLotModal, setShowNextLotModal] = useState(false);
  // const [timer, setTimer] = useState({ ...initialTimer });

  // list
  const [data, setData] = useState({});
  const [auction, setAuction] = useState({});
  const [modalWinner, setModalWinner] = useState({});
  const [images, setImages] = useState([]);
  const [nextLots, setNextLots] = useState([]);
  const [nextLotsPage, setNextLotsPage] = useState(1);
  const [nextLotsTotalPage, setNextLotsTotalPage] = useState(1);
  const [nextLotsLoading, setNextLotsLoading] = useState(false);
  const [biddingList, setBiddingList] = useState([]);
  const [proxyList, setProxyList] = useState([]);
  const [cancelProxy, setCancelProxy] = useState({
    currentUnitId: null,
    isOpenModal: false,
    count: 0,
  });
  const [responErrorBid, setResponseErrorBid] = useState({
    offer_price: 0,
    response: null,
  });

  // bid
  const [offer, setOffer] = useState(0);
  const [error, setError] = useState("");
  const [transactionId, setTransactionId] = useState({ loading: false, data: null });
  const [checkoutMessage, setCheckoutMessage] = useState("");
  const [showFallback, setShowFallback] = useState(false);
  const [highestBid, setHighestBid] = useState({ ...initialBid });
  const [multipleBid, setMultipleBid] = useState(0);
  const [counter, setCounter] = useState(null);

  // loader
  const [unitLoader, setUnitLoader] = useState(false);
  const [nextUnitLoader, setNextUnitLoader] = useState(false);
  const [bidLoader, setBidLoader] = useState(false);
  const [socketStatus, setSocketStatus] = useState("connecting");
  // Latency socket ke server (ms) dari ping/pong socket.io, untuk indikator koneksi.
  const [latencyMs, setLatencyMs] = useState(null);
  useEffect(() => {
    if (socketStatus !== "connected") setLatencyMs(null);
  }, [socketStatus]);
  const [reconnectAttempts, setReconnectAttempts] = useState(0);
  const [maxReconnectReached, setMaxReconnectReached] = useState(false);
  const [currentUnit, setCurrentUnit] = useState(null);

  const prevUnitId = useRef();
  const reconnectCountRef = useRef(0);
  const stableConnectionTimerRef = useRef(null);
  const shouldEmitTotalNipl = useRef(true); // Track if we should emit TotalNipl on next bid
  const lastRejoinOnErrorRef = useRef(0); // Track last rejoin timestamp to prevent infinite loop
  const REJOIN_COOLDOWN_MS = 10000; // 10 seconds cooldown between rejoins on error

  const URL = process.env.REACT_APP_SOCKET;
  const token = localStorage.getItem("token");
  const AccessToken = `Bearer ${token}`;
  const MAX_RECONNECT_ATTEMPTS = 10;
  const STABLE_CONNECTION_DELAY = 5000; // 5 seconds of stable connection before reset

  const socketRef = useRef(null);
  const auctionSocketRoom = `auction:${id}`;

  if (!socketRef.current) {
    socketRef.current = io(URL, {
      query: { token: AccessToken },
      transports: ["websocket"],
      autoConnect: true,
      reconnection: true,
      reconnectionAttempts: MAX_RECONNECT_ATTEMPTS,
      reconnectionDelay: 2000,
      timeout: 10000,
      forceNew: false,
    });
  }

  const socket = socketRef.current;

  const handleJoinAuction = useCallback(() => {
    if (!socketRef.current) {
      console.warn("⚠️ Cannot join auction: socket is null");
      return;
    }

    if (!socketRef.current.connected) {
      console.warn("⚠️ Cannot join auction: socket not connected");
      return;
    }

    console.log("🔔 Emitting JoinAuction to room:", auctionSocketRoom);
    socketRef.current.emit("JoinAuction", {
      room: auctionSocketRoom,
    });
  }, [auctionSocketRoom]);

  const toastError = useCallback((message) => showBidErrorToast(message), []);

  const handleCheckout = useCallback(async () => {
    if (transactionId?.data?.id) {
      push(`/pengaturan/transaksi/pembelian/${transactionId.data.id}`);
      return;
    }

    if (!modalWinner?.part_one_invoice) {
      push(`/pengaturan/transaksi`);
      return;
    }

    const params = { ...modalWinner.part_one_invoice };
    let maxRetries = 3;

    setTransactionId({ loading: true, data: null });
    setCheckoutMessage("Invoice sedang di proses, halaman otomatis pindah dalam 5 detik");
    setShowFallback(false);

    const tryGenerate = async () => {
      try {
        const response = await withAuth.postDataWithAuth(`/api/create/invoice`, params);
        if (response?.status === 200) {
          const invoiceId = response?.data?.data?.id;
          setTransactionId({ loading: false, data: { id: invoiceId } });
          setCheckoutMessage("");
          push(`/pengaturan/transaksi/pembelian/${invoiceId}`);
          return true;
        } else if (response?.status === 404) {
          // Proses generate masih sedang berlangsung
          return false;
        } else {
          toastError(response?.data?.message || "Failed to fetch data");
          return false; // Stop on other errors? Or retry? Let's just return false to retry anyway.
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        return false;
      }
    };

    let success = await tryGenerate();
    if (success) return;

    for (let i = 1; i <= maxRetries; i++) {
      // Wait 5 seconds before next retry
      await new Promise((resolve) => setTimeout(resolve, 5000));

      success = await tryGenerate();
      if (success) return;
    }

    // If we reach here, max retries exceeded
    setTransactionId((prev) => ({ ...prev, loading: false }));
    setShowFallback(true);
    setCheckoutMessage("");
  }, [transactionId, modalWinner, push, toastError]);

  // Fetch Next Lots & Not Sell via API
  const nextLotsPageRef = useRef(1);
  const currentNextLotSlideRef = useRef(0);
  const fetchNextLots = useCallback(async (page = 1, append = false) => {
    setNextLotsLoading(true);
    try {
      const response = await withAuth.getDataWithAuth(`/api/auction-live/${id}/list-next-lot`, { page, page_size: 10 });

      if (!response || response?.data?.status === false) {
        console.warn("fetchNextLots: invalid response", response?.data);
        return;
      }

      const resData = response?.data?.data;
      const items = [...(resData?.next_lot || []), ...(resData?.not_sell || [])];
      const currentPage = resData?.page != null ? resData.page : page;
      const totalPage = resData?.total_page != null ? resData.total_page : 1;

      nextLotsPageRef.current = currentPage;
      setNextLots((prev) => append ? [...prev, ...items] : items);
      setNextLotsPage(currentPage);
      setNextLotsTotalPage(totalPage);
    } catch (error) {
      console.error("Error fetching next lots:", error);
    } finally {
      setNextLotsLoading(false);
    }
  }, [id]);

  //Fetch Proxy Bid List
  const getProxyBidList = useCallback(
    async (stockUnitId, auctionId) => {
      if (!stockUnitId || !auctionId) {
        console.warn("Missing stockUnitId or auctionId for proxy bid fetch");
        return;
      }

      try {
        const params = { stock_unit_id: stockUnitId, auction_id: auctionId };
        const response = await withAuth.getDataWithAuth("/api/proxy-bid/v2", params);

        if (response?.status === 200 && response?.data?.status) {
          // Handle new API response structure
          const proxyBidData = response.data.data?.data || [];
          setProxyList(
            proxyBidData.map((el) => ({
              id: el.id,
              stock_unit_id: el.stock_unit_id,
              buyer_id: el.buyer_id,
              offer_price: parseInt(el.offer_price),
              buyer_nipl_id: el.nipl?.id || null,
              nipl: el.nipl || null,
              buyer: el.buyer || null,
              is_cancelled: false, // Default value, update if API provides this
            }))
          );
        } else {
          setProxyList([]);
          toastError("Failed to fetch proxy bid data");
        }
      } catch (error) {
        console.error("Error fetching proxy bid:", error);
        toastError("Failed to fetch proxy bid data");
        setProxyList([]);
      }
    },
    [toastError]
  );

  // Handler
  const changeOffer = (val) => {
    const value = parseInt(val);
    let newError = "";

    if (!val || isNaN(value) || value <= 0) {
      newError = "Penawaran tidak boleh kosong atau tidak valid";
    } else if (multipleBid > 0 && value % multipleBid !== 0) {
      newError = `Penawaran harus kelipatan ${multipleBid.toLocaleString()}`;
    } else if (value < highestBid.offer_price) {
      newError = `Penawaran harus lebih besar dari penawaran saat ini`;
    } else {
      newError = "";
    }
    setError(newError);
    setOffer(value);
  };

  const bidHandler = () => {
    if (disableBid === "off") {
      setDisabledBid("on");
    } else {
      setDisabledBid("off");
    }
  };

  const postBid = async () => {
    setIsProcess("on");
    if (responErrorBid.response === slowerBidder && responErrorBid.offer_price === offer) {
      toastError(slowerBidder);
      setIsProcess("off");
      return;
    }
    if (responErrorBid.response === niplOutOfStock) {
      toastError(niplOutOfStock);
      setIsProcess("off");
      return;
    }
    if (highestBid?.email === thisUser?.email) {
      toastError("Bid Anda sudah paling atas!");
      setIsProcess("off");
      return;
    }

    if (error.length > 0) {
      toastError(error);
      setIsProcess("off");
      return;
    }

    try {
      const params = {
        room: auctionSocketRoom,
        offer: offer,
        unit_id: data?.id,
        is_conductor: false,
        is_master: 0,
      };

      const response = await withAuth.postDataWithAuth("/api/auction-live/send-bid", params);

      if (response?.status === 200 && response?.data?.status) {
        // Emit TotalNipl only on first bid or after NextLot
        if (shouldEmitTotalNipl.current && id) {
          socket.emit("TotalNipl", {
            auction_id: parseInt(id, 10),
            unit_id: data?.id,
          });
          shouldEmitTotalNipl.current = false; // Disable for subsequent bids
        }

        // Show success notification
        toast.success("Penawaran berhasil dikirim", {
          id: "bid-success-message",
          duration: 3000,
        });
      } else {
        // Handle error response from API
        let errorMessage = "Gagal mengirim penawaran";

        if (response?.data?.errors?.details) {
          errorMessage = response.data.errors.details;
        } else if (response?.data?.message) {
          errorMessage = response.data.message;
        }

        toastError(errorMessage);
      }
    } catch (error) {
      console.error("Error sending bid:", error);

      // Parse error from catch block
      let errorMessage = "Gagal mengirim penawaran";

      if (error?.response?.data?.errors?.details) {
        errorMessage = error.response.data.errors.details;
      } else if (error?.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error?.message) {
        errorMessage = error.message;
      }

      toastError(errorMessage);
    } finally {
      setIsProcess("off");
    }
  };

  // Optimized data processing utilities
  const getBidderDisplayName = useCallback((bidder, thisUser) => {
    // Cek apakah bidder adalah user saat ini berdasarkan user_id
    const isCurrentUser = bidder?.buyer_user_id && bidder?.buyer_user_id === thisUser?.id;

    // Jika adalah user saat ini (termasuk proxy bid dari user), tampilkan "Saya"
    if (isCurrentUser) {
      return "Saya";
    }

    // Jika bukan user saat ini, tampilkan type-nya
    return bidder?.type || "-";
  }, []);

  const processBidderData = useCallback((bidders) => {
    if (!bidders || bidders.length === 0) return { highestBid: null, biddingList: [] };

    const processedBidders = bidders
      .slice()
      .reverse()
      .map((bidder) => {
        // Determine the type
        let type = "Online Bidder";
        if (bidder.email === "Proxy bid" || bidder.email === "Proxy bidder") {
          // If it's a proxy bid from current user, mark as "Proxy bid" but will be displayed as "Saya"
          type = "Proxy bid";
        } else if (bidder.email === "Offline Bidder") {
          type = "Offline Bidder";
        }

        return {
          ...bidder,
          type,
          offer_price: parseInt(bidder.offer) || 0,
          buyer_user_id: bidder.user_id || null,
        };
      });

    const highestBid = {
      email: processedBidders[0]?.email || "",
      buyer_user_id: processedBidders[0]?.buyer_user_id || null,
      offer_price: parseInt(processedBidders[0]?.offer_price) || 0,
      type: processedBidders[0]?.type || "Harga Dasar",
    };

    const biddingList = processedBidders.filter((_, idx) => idx !== 0);

    return { highestBid, biddingList };
  }, []);

  const handleSocketAuction = useCallback(
    (auctionData, skipTotalNiplUpdate = false) => {
      try {
        const currentAuction = auctionData?.auction || {};

        // Only update auction status if auction object exists
        if (auctionData?.auction) {
          if (currentAuction?.status === "CLOSED") {
            setIsOpen(false);
          }

          setAuction({
            ...currentAuction,
            nipls_count: auctionData?.auction_nipls?.length || 0,
          });
          setLiveAuction(currentAuction?.status);

          // Check if auction is STARTED but seconds_left_before is 0 (selecting winner state)
          if (
            currentAuction?.status === "STARTED" &&
            (auctionData?.seconds_left_before === 0 || auctionData?.seconds_left_before === null)
          ) {
            setIsSelectingWinner(true);
          } else {
            setIsSelectingWinner(false);
          }
        }

        if (auctionData?.current_unit !== null && auctionData?.current_unit?.length > 0) {
          let unitNow = auctionData?.current_unit?.[0] || {};

          // Normalize data structure untuk kompatibilitas
          const normalizedUnit = {
            ...unitNow,
            // Map stock_only_value_informations ke stock_informations jika tidak ada
            stock_informations: unitNow?.stock_informations || unitNow?.stock_only_value_informations || [],
            // Map stock_document_only_value ke stock_documents jika tidak ada
            stock_documents: unitNow?.stock_documents || unitNow?.stock_document_only_value || [],
          };

          setData(normalizedUnit);

          // nextLots now fetched via API (fetchNextLots), not from socket response

          setImages(normalizedUnit?.pictures || []);

          // Process bidder data using utility function
          const { highestBid: processedHighestBid, biddingList: processedBiddingList } = processBidderData(
            unitNow?.bidders
          );

          const newHighestBid = processedHighestBid || {
            email: "base_price",
            type: "Harga Dasar",
            offer_price: unitNow?.base_price || 0,
          };

          setHighestBid(newHighestBid);
          setBiddingList(processedBiddingList);

          // Safe access to multiple_bid with fallback to existing auction state
          const multipleBidAmount = currentAuction?.unit_type?.multiple_bid || auction?.unit_type?.multiple_bid || 0;
          setMultipleBid(multipleBidAmount);
          // setProxyList(auctionData?.proxy_bids || []);

          let nextOffer = 0;
          if (unitNow?.current_price !== null && unitNow?.current_price !== undefined) {
            const currentPrice = parseInt(unitNow.current_price);
            nextOffer = !isNaN(currentPrice) ? currentPrice + multipleBidAmount : 0;
          } else if (unitNow?.bidders?.length > 0) {
            const lastBidder = unitNow?.bidders[unitNow?.bidders?.length - 1];
            const lastBid = parseInt(lastBidder?.offer);
            nextOffer = !isNaN(lastBid) ? lastBid + multipleBidAmount : 0;
          } else {
            const basePrice = parseInt(unitNow?.base_price);
            nextOffer = !isNaN(basePrice) ? basePrice : 0;
          }
          setOffer(nextOffer);
          setBlockBid("off");
        }

        // Update key and counter only once at the end of the function
        setKey((prev) => prev + 1);
        setCounter(auctionData?.seconds_left_before || null);

        // Only update total_nipl if not skipped (skip for SendBidResponse)
        if (!skipTotalNiplUpdate) {
          setTotalNipl(auctionData?.total_nipl || 0);
        }

        setUnitLoader(false);
        setBidLoader(false);
        setNextUnitLoader(false);
      } catch (error) {
        console.error("Error stack:", error.stack);
        // Don't throw, just log to prevent blank screen
      }
    },
    [processBidderData, auction]
  );

  const showModal = useCallback(() => {
    dispatch(actionsLiveAuction.setModal({ modal: true }));
    setModalResult(true);
  }, [dispatch]);

  const closeModal = useCallback(() => {
    dispatch(actionsLiveAuction.setModal({ modal: false }));
    setModalResult(false);
  }, [dispatch]);

  const secondsToTime = (secs) => {
    let divisor_for_minutes = secs % (60 * 60);
    let minutes = Math.floor(divisor_for_minutes / 60);

    let divisor_for_seconds = divisor_for_minutes % 60;
    let seconds = Math.ceil(divisor_for_seconds);

    return zeroPad(minutes) + ":" + zeroPad(seconds);
  };

  // Consolidated date formatting utilities
  const formatAuctionDate = useCallback((dateStart, timeStart, formatType = "date") => {
    if (!dateStart || !timeStart) return "-";

    const dateString = `${dateStart} ${timeStart}`;
    const dateObj = new Date(dateString);

    if (isNaN(dateObj)) return "-";

    switch (formatType) {
      case "date":
        return format(dateObj, "dd MMM yyyy");
      case "time":
        return format(dateObj, "HH:mm");
      default:
        return "-";
    }
  }, []);

  const formatAuctionTimeRange = useCallback(
    (dateStart, timeStart, timeFinish) => {
      const startTime = formatAuctionDate(dateStart, timeStart, "time");
      const endTime = formatAuctionDate(dateStart, timeFinish, "time");

      if (startTime === "-" || endTime === "-") return "-";

      return `${startTime} - ${endTime} WIB`;
    },
    [formatAuctionDate]
  );

  // Consolidated UI components
  const UnitInformation = useCallback(({ informations, documents }) => {
    // Safety check untuk memastikan data adalah array
    const safeInformations = Array.isArray(informations) ? informations : [];
    const safeDocuments = Array.isArray(documents) ? documents : [];

    const allInfo = [
      ...safeInformations.filter((el) => el?.value !== "" && el?.value !== null && el?.value !== undefined),
      ...safeDocuments.filter((el) => el?.value !== "" && el?.value !== null && el?.value !== undefined),
    ];

    if (allInfo.length === 0) {
      return (
        <div className="unit-information-wrapper">
          <p className="text-muted">Tidak ada informasi tersedia</p>
        </div>
      );
    }

    return (
      <div
        className="unit-information-wrapper"
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))",
          gap: "8px",
        }}
      >
        {allInfo.map(({ label, value }, idx) => (
          <div className="informasi-unit-auction" key={`information-${idx + 1}`}>
            <span className="title">{label || "-"}</span>
            <span className="value">
              {isDate(value) ? moment(value).format("DD MMM YYYY") : value !== "null" && value ? value : "-"}
            </span>
          </div>
        ))}
      </div>
    );
  }, []);

  const ResponsiveBidderDisplay = useCallback(
    ({ highestBid, thisUser }) => {
      const bidderName = getBidderDisplayName(highestBid, thisUser);

      return (
        <>
          {/* Desktop view */}
          <div className="d-none d-md-block px-4 pb-4">
            <div className="highest-bid border" style={{ borderRadius: "0.5rem" }}>
              <span className="bid-value">
                Rp {highestBid?.offer_price ? highestBid?.offer_price?.toLocaleString() : "-"}
              </span>
              <span className="bidder">{bidderName}</span>
            </div>
          </div>
          {/* Mobile view */}
          <div className="d-block d-md-none px-4 pb-4">
            <div className="highest-bid d-flex border" style={{ borderRadius: "0.5rem" }}>
              <span className="bid-value" style={{ fontSize: "20px" }}>
                Rp {highestBid?.offer_price ? highestBid?.offer_price?.toLocaleString() : "-"}
              </span>
              <span className="bidder" style={{ fontSize: "16px" }}>
                {bidderName}
              </span>
            </div>
          </div>
        </>
      );
    },
    [getBidderDisplayName]
  );

  // Optimized data processing utilities
  const processUnitDetails = useCallback((item) => {
    const unitInformations = (item?.unit_informations || []).filter(info => info.is_visible !== 0);
    const unitDocuments = item?.unit_documents || [];

    const year = unitInformations.find((info) => info.label === "Tahun");
    const odometer = unitInformations.find((info) => info.label === "Odometer");
    const transmisi = unitInformations.find((info) => info.label === "Transmisi");
    const fuel = unitInformations.find((info) => info.label === "Bahan Bakar");
    const validityPeriod = unitDocuments.find((doc) => doc.label === "STNK");

    return {
      police_number: item?.police_number,
      year: year?.value,
      odometer: odometer?.value,
      transmisi: transmisi?.value,
      fuel: fuel?.value,
      validityPeriod: validityPeriod?.additional_value,
    };
  }, []);

  // Consolidated socket event handlers
  const handleSocketEvent = useCallback(
    (eventType, response) => {
      console.log(`📩 ${eventType}:`, response);

      // Validate response data (skip validation for TotalNiplResponse as it has different structure)
      if (eventType !== "TotalNiplResponse" && !response?.data) {
        console.warn(`⚠️ ${eventType}: Invalid response data`);
        return;
      }

      // Update auction state first (skip for TotalNiplResponse as it doesn't have auction data)
      // For SendBidResponse, skip total_nipl and nextLots update
      if (eventType !== "TotalNiplResponse") {
        const skipTotalNiplUpdate = eventType === "SendBidResponse";
        handleSocketAuction(response.data, skipTotalNiplUpdate);
      }

      // Handle specific event logic
      switch (eventType) {
        case "SendBidResponse": {
          // Regular Auction typically has the current unit at index 0 of current_unit
          const currUnit = response?.data?.current_unit?.[0];

          const socketBidders = currUnit?.bidders;

          // No need to show toast here, it's already handled in postBid function
          setIsProcess("off");
          break;
        }

        case "NextLotResponse": {
          const extra = response?.extra || null;

          // Fetch updated next lots from API
          fetchNextLots(1, false);
          currentNextLotSlideRef.current = 0;

          // Set modal winner data from extra (winner unit data)
          if (extra?.unit) {
            setModalWinner({
              ...extra.unit,
              lot: extra?.lot || null,
              offer_price: extra?.offer || extra?.unit?.current_price || 0,
              buyer: extra?.buyer || null,
              part_one_invoice: extra?.part_one_invoice || null,
            });
          } else {
            setModalWinner(null);
          }

          // Show modal and generate invoice if current user is the winner
          if (extra?.buyer?.user_id === thisUser?.id) {
            showModal();
          } else {
            // Show modal next lot for 3 seconds only if unit data exists
            setResult(extra?.buyer ? "TERJUAL" : "TIDAK TERJUAL");
            setShowNextLotModal(true);

            // Auto close modal after 3 seconds
            setTimeout(() => {
              setShowNextLotModal(false);
              setCurrentUnit(response?.data?.current_unit?.[0]);
            }, 3000);
          }

          // Reset flag to allow TotalNipl emit on next bid
          shouldEmitTotalNipl.current = true;

          // Force update unit data from NextLotResponse to ensure new unit is displayed
          const nextUnitData = response?.data?.current_unit?.[0];
          if (nextUnitData) {
            // Normalize data structure untuk kompatibilitas (sama seperti di handleSocketAuction)
            const normalizedNextUnit = {
              ...nextUnitData,
              // Map stock_only_value_informations ke stock_informations jika tidak ada
              stock_informations: nextUnitData?.stock_informations || nextUnitData?.stock_only_value_informations || [],
              // Map stock_document_only_value ke stock_documents jika tidak ada
              stock_documents: nextUnitData?.stock_documents || nextUnitData?.stock_document_only_value || [],
            };

            setData(normalizedNextUnit);
            setImages(normalizedNextUnit?.pictures || []);

            // Reset bidding state for new unit
            if (!nextUnitData?.bidders || nextUnitData?.bidders?.length === 0) {
              setHighestBid({
                email: "base_price",
                type: "Harga Dasar",
                offer_price: nextUnitData?.base_price || 0,
              });
              setBiddingList([]);
              setOffer(nextUnitData?.base_price || 0);
            }
          }

          // Request updated NIPL count
          if (response.data.auction?.id) {
            socket.emit("TotalNipl", {
              auction_id: response.data.auction.id,
              unit_id: response?.data?.current_unit?.[0]?.id,
            });
          }
          break;
        }

        case "TotalNiplResponse": {
          // Handle NIPL response data
          console.log("📊 Full TotalNiplResponse:", response);

          // Try to get data from different possible structures
          let niplData = response?.data?.data || response?.data;
          const remaining = niplData.total_nipl;

          if (niplData && niplData.total_nipl !== undefined) {
            setSpecialNIPLToggle((prev) => {
              // Only update if prev is an object (not false)
              if (typeof prev === "object" && prev !== null) {
                const newState = {
                  ...prev,
                  remaining_nipls: remaining,
                  used_nipls_this_stock_unit: niplData.in_use || 0,
                };
                console.log("📊 New SpecialNIPLToggle state:", newState);
                return newState;
              }
              return prev; // Keep current state if not an object
            });
          } else {
            console.warn("⚠️ TotalNiplResponse: Could not find NIPL data", response);
          }
          break;
        }

        case "JoinAuctionResponse":
        case "PendingResponse":
        case "StartAuctionResponse": {
          // Request NIPL count when joining or starting auction
          if (response.data.auction?.id && response.data.auction?.status === "STARTED") {
            socket.emit("TotalNipl", {
              auction_id: response.data.auction.id,
              unit_id: response?.data?.current_unit?.[0]?.id,
            });
          }
          // Fetch next lots from API on join/start
          fetchNextLots(1, false);
          currentNextLotSlideRef.current = 0;
          setCurrentUnit(response?.data?.current_unit?.[0]);
          break;
        }

        default:
          console.log(`ℹ️ Unhandled event type: ${eventType}`);
          break;
      }
    },
    [thisUser?.id, showModal, handleSocketAuction, socket, fetchNextLots]
  );

  const handleSocketError = useCallback(
    (err) => {
      console.log("❌ error:", err);

      // Parse error message with priority:
      // 1. errors.details (specific error detail from nested errors object)
      // 2. message (general error message)
      // 3. err.message (fallback for standard Error objects)
      let responseDataError = "Terjadi kesalahan";

      // Handle different error structures
      if (err?.errors?.details) {
        // Case: {"errors": {"details": "NIPL Tidak Cukup..."}}
        responseDataError = err.errors.details;
      } else if (err?.message) {
        // Case: {"message": "Internal Server Error"}
        responseDataError = err.message;
      } else if (typeof err === "string") {
        // Case: error is already a string
        responseDataError = err;
      } else if (err?.error) {
        // Case: {"error": "Some error message"}
        responseDataError = err.error;
      }

      const bidFound = errorSendBidMessages.find((element) => element === responseDataError);
      if (bidFound) {
        setResponseErrorBid({
          offer_price: offer,
          response: responseDataError,
        });
      }

      toast.error(responseDataError, {
        id: "error-message",
        duration: 3000,
      });

      // Reset process state when error occurs
      setIsProcess("off");

      // Auto rejoin room after bid error to ensure sync with server
      // Only rejoin if cooldown period has passed to prevent infinite loop
      const now = Date.now();
      const timeSinceLastRejoin = now - lastRejoinOnErrorRef.current;

      if (socketRef.current?.connected && timeSinceLastRejoin >= REJOIN_COOLDOWN_MS) {
        console.log("🔄 Rejoining auction room after bid error...");
        lastRejoinOnErrorRef.current = now;
        setTimeout(() => {
          handleJoinAuction();
        }, 500); // Small delay to ensure error is processed
      } else if (timeSinceLastRejoin < REJOIN_COOLDOWN_MS) {
        console.log(
          `⏳ Rejoin cooldown active. Wait ${Math.ceil((REJOIN_COOLDOWN_MS - timeSinceLastRejoin) / 1000)}s before next rejoin`
        );
      }
    },
    [offer, handleJoinAuction]
  );

  useEffect(() => {
    console.log("🟡 Setting up socket listeners...");

    // Guard clause: ensure socket exists
    if (!socketRef.current) {
      console.warn("⚠️ Socket ref is null, skipping listener setup");
      return;
    }

    // Socket event listeners - define all handlers with proper references
    const handleConnect = () => {
      console.log("✅ Connected to server");
      setSocketStatus("connected");
      handleJoinAuction();

      // Clear any existing timer
      if (stableConnectionTimerRef.current) {
        clearTimeout(stableConnectionTimerRef.current);
      }

      // Reset counter only after stable connection (5 seconds)
      stableConnectionTimerRef.current = setTimeout(() => {
        console.log("🟢 Connection stable, resetting reconnect counter");
        reconnectCountRef.current = 0;
        setReconnectAttempts(0);
        setMaxReconnectReached(false);
      }, STABLE_CONNECTION_DELAY);
    };

    const handleDisconnect = (reason) => {
      console.log("🔌 Disconnected from server:", reason);
      setSocketStatus("disconnected");

      // Clear stable connection timer on disconnect
      if (stableConnectionTimerRef.current) {
        clearTimeout(stableConnectionTimerRef.current);
        stableConnectionTimerRef.current = null;
      }
    };

    const handleReconnect = (attemptNumber) => {
      console.log(`🔄 Reconnected to server (attempt ${attemptNumber})`);
      setSocketStatus("connected");
      handleJoinAuction();

      // Clear any existing timer
      if (stableConnectionTimerRef.current) {
        clearTimeout(stableConnectionTimerRef.current);
      }

      // Reset counter only after stable connection (5 seconds)
      stableConnectionTimerRef.current = setTimeout(() => {
        console.log("🟢 Connection stable, resetting reconnect counter");
        reconnectCountRef.current = 0;
        setReconnectAttempts(0);
        setMaxReconnectReached(false);
      }, STABLE_CONNECTION_DELAY);
    };

    const handleReconnectAttempt = (attemptNumber) => {
      // Increment cumulative counter
      reconnectCountRef.current += 1;
      const totalAttempts = reconnectCountRef.current;

      console.log(`🔄 Reconnection attempt ${totalAttempts} of ${MAX_RECONNECT_ATTEMPTS}`);
      setReconnectAttempts(totalAttempts);
      setSocketStatus("reconnecting");

      if (totalAttempts >= MAX_RECONNECT_ATTEMPTS) {
        console.log("💥 Maximum reconnection attempts reached");
        setMaxReconnectReached(true);
        setSocketStatus("failed");
        // Disconnect socket to stop further attempts
        if (socketRef.current) {
          socketRef.current.disconnect();
        }
      }
    };

    const handleReconnectError = (error) => {
      console.log("❌ Reconnection error:", error);
      setSocketStatus("reconnecting");
    };

    const handleReconnectFailed = () => {
      console.log("💥 Reconnection failed");
      setSocketStatus("failed");
      setMaxReconnectReached(true);
    };

    const handleConnectError = (err) => {
      console.log("❌ Connection error:", err.message);
    };

    // Define all event handlers with proper references for cleanup
    const handleJoinAuctionResponse = (response) => handleSocketEvent("JoinAuctionResponse", response);
    const handleFloorResponse = (response) => handleSocketEvent("FloorResponse", response);
    const handleStartAuctionResponse = (response) => handleSocketEvent("StartAuctionResponse", response);
    const handleTotalNiplResponse = (response) => handleSocketEvent("TotalNiplResponse", response);
    const handlePendingResponse = (response) => handleSocketEvent("PendingResponse", response);
    const handleReSellResponse = (response) => handleSocketEvent("ReSellResponse", response);
    const handleSendBidResponse = (response) => handleSocketEvent("SendBidResponse", response);
    const handleNextLotResponse = (response) => handleSocketEvent("NextLotResponse", response);
    const handleSetAutopilotResponse = (response) => handleSocketEvent("SetAutopilotResponse", response);

    // Event listeners
    const handlePong = (latency) => setLatencyMs(latency);
    socketRef.current.on("connect", handleConnect);
    socketRef.current.on("pong", handlePong);
    socketRef.current.on("disconnect", handleDisconnect);
    socketRef.current.on("reconnect", handleReconnect);
    socketRef.current.on("reconnect_attempt", handleReconnectAttempt);
    socketRef.current.on("reconnect_error", handleReconnectError);
    socketRef.current.on("reconnect_failed", handleReconnectFailed);
    socketRef.current.on("connect_error", handleConnectError);
    // Room listeners
    socketRef.current.on("JoinAuctionResponse", handleJoinAuctionResponse);
    socketRef.current.on("FloorResponse", handleFloorResponse);
    socketRef.current.on("StartAuctionResponse", handleStartAuctionResponse);
    socketRef.current.on("TotalNiplResponse", handleTotalNiplResponse);
    socketRef.current.on("PendingResponse", handlePendingResponse);
    socketRef.current.on("ReSellResponse", handleReSellResponse);
    socketRef.current.on("SendBidResponse", handleSendBidResponse);
    socketRef.current.on("NextLotResponse", handleNextLotResponse);
    socketRef.current.on("SetAutopilotResponse", handleSetAutopilotResponse);
    socketRef.current.on("error", handleSocketError);

    // Connect if not already connected
    if (!socketRef.current.connected) {
      console.log("🔄 Attempting to connect...");
      socketRef.current.connect();
    }

    return () => {
      console.log("🛑 Cleaning up socket listeners...");

      // Clear stable connection timer
      if (stableConnectionTimerRef.current) {
        clearTimeout(stableConnectionTimerRef.current);
        stableConnectionTimerRef.current = null;
      }

      // Remove all listeners with proper function references
      if (socketRef.current) {
        socketRef.current.off("connect", handleConnect);
        socketRef.current.off("pong", handlePong);
        socketRef.current.off("disconnect", handleDisconnect);
        socketRef.current.off("reconnect", handleReconnect);
        socketRef.current.off("reconnect_attempt", handleReconnectAttempt);
        socketRef.current.off("reconnect_error", handleReconnectError);
        socketRef.current.off("reconnect_failed", handleReconnectFailed);
        socketRef.current.off("connect_error", handleConnectError);

        socketRef.current.off("JoinAuctionResponse", handleJoinAuctionResponse);
        socketRef.current.off("StartAuctionResponse", handleStartAuctionResponse);
        socketRef.current.off("TotalNiplResponse", handleTotalNiplResponse);
        socketRef.current.off("PendingResponse", handlePendingResponse);
        socketRef.current.off("ReSellResponse", handleReSellResponse);
        socketRef.current.off("SendBidResponse", handleSendBidResponse);
        socketRef.current.off("FloorResponse", handleFloorResponse);
        socketRef.current.off("NextLotResponse", handleNextLotResponse);
        socketRef.current.off("SetAutopilotResponse", handleSetAutopilotResponse);
        socketRef.current.off("error", handleSocketError);
      }
    };
  }, [handleJoinAuction, handleSocketEvent, handleSocketError]);

  // Handle room changes when id changes
  useEffect(() => {
    if (socketRef.current && socketRef.current.connected) {
      console.log("🔄 Room changed, rejoining auction...");
      handleJoinAuction();
    }
  }, [id, handleJoinAuction]);

  // Cleanup socket on component unmount
  useEffect(() => {
    return () => {
      console.log("🛑 Component unmounting, disconnecting socket...");
      if (socketRef.current) {
        socketRef.current.disconnect();
        socketRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    if (auction.current_stock_unit_id !== cancelProxy.currentUnitId) {
      const cancelledProxy = auction?.proxy_bid?.length > 0 ? auction.proxy_bid[0] : null;

      // setResult("LOADING");
      setCancelProxy((prev) => ({
        ...prev,
        currentUnitId: auction.current_stock_unit_id,
        isOpenModal: cancelledProxy && cancelledProxy.is_cancelled,
        count: prev.count + 1,
      }));
    }
  }, [auction, cancelProxy]);

  useEffect(() => {
    if (prevUnitId.current !== auction.current_stock_unit_id) {
      setUnitLoader(true);
      setBidLoader(true);
      setNextUnitLoader(true);
    }

    prevUnitId.current = auction?.current_stock_unit_id;
  }, [auction]);

  useEffect(() => {
    let timer = null;

    if (counter > 0) {
      timer = setInterval(() => setCounter((prev) => prev - 1), 1000);
      setIsOpen(false);
    }

    if (counter === 0) {
      dispatch(actionsLiveAuction.setCurrentDataUnit({ unit: data }));
      setDataModal((prev) => ({
        ...prev,
        lot_number: auction?.auction_lane_name || "",
      }));
      if (liveAuction !== "PENDING" && liveAuction !== "CLOSED" && !isSelectingWinner) {
        setResult("LOADING");
        setIsOpen(true);
      }
    } else if (counter <= 3) {
      setBlockBid("on");
      setColor("secondary");
    } else if (counter <= 5) {
      setColor("danger");
    } else if (counter <= 10) {
      setColor("orange");
    } else if (counter <= 15) {
      setColor("warning");
    } else if (counter > 15) {
      setColor("success");
    }

    return () => {
      if (timer) clearInterval(timer);
    };
  }, [counter, data, auction, liveAuction, dispatch, isSelectingWinner]);

  useEffect(() => {
    localStorage.removeItem(`highBidRA-${id}`);
    localStorage.removeItem(`listBidderRA-${id}`);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Fetch proxy bid list when unit or auction changes
  useEffect(() => {
    if (data?.id && id) {
      getProxyBidList(data.id, id);
    }
  }, [data?.id, id, getProxyBidList]);

  useEffect(() => {
    let blocked = "off";
    if (proxyList?.length > 0) {
      // Filter proxy yang tidak dibatalkan dan cari yang tertinggi
      const activeProxies = proxyList.filter((proxy) => !proxy.is_cancelled);
      if (activeProxies.length > 0) {
        const highestProxy = activeProxies.reduce((highest, current) =>
          current.offer_price > highest.offer_price ? current : highest
        );
        if (highestProxy.offer_price > highestBid?.offer_price) {
          blocked = "on";
        }
      }
    }
    setBlockBid(blocked);
  }, [highestBid.offer_price, proxyList]);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible" && socketRef.current && socketRef.current.connected) {
        console.log("👁️ Page became visible, rejoining auction...");
        handleJoinAuction();
      }
    };

    const handleFocus = () => {
      if (socketRef.current && socketRef.current.connected) {
        console.log("🎯 Window focused, rejoining auction...");
        handleJoinAuction();
      }
    };

    const handleOnline = () => {
      console.log("🌐 Network back online, reconnecting...");
      if (socketRef.current && !socketRef.current.connected) {
        socketRef.current.connect();
      }
    };

    const handleOffline = () => {
      console.log("📴 Network offline");
    };

    // Add event listeners
    window.addEventListener("focus", handleFocus);
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      window.removeEventListener("focus", handleFocus);
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [handleJoinAuction]);

  const isReady = useMemo(() => !bidLoader && !unitLoader && !nextUnitLoader, [bidLoader, unitLoader, nextUnitLoader]);

  // Socket status indicator
  const getSocketStatusColor = () => {
    switch (socketStatus) {
      case "connected":
        return socketConnected;
      case "connecting":
        return socketReconnecting;
      case "reconnecting":
        return socketDisconnected;
      case "disconnected":
        return socketError;
      case "failed":
        return socketUnknown;
      default:
        return socketUnknown;
    }
  };

  const getSocketStatusText = () => {
    switch (socketStatus) {
      case "connected":
        return "Terhubung";
      case "connecting":
        return "Menghubungkan...";
      case "reconnecting":
        return `Mencoba ulang... (${reconnectAttempts}/${MAX_RECONNECT_ATTEMPTS})`;
      case "disconnected":
        return "Terputus";
      case "failed":
        return maxReconnectReached ? "Koneksi gagal" : "Gagal terhubung";
      default:
        return "Tidak diketahui";
    }
  };

  const handleRefreshPage = () => {
    window.location.reload();
  };

  return (
    <>
      {/* Latency koneksi saat terhubung */}
      {socketStatus === "connected" && <ConnectionLatency latencyMs={latencyMs} />}

      {/* Socket Status Indicator */}
      {socketStatus !== "connected" && (
        <div
          style={{
            position: "fixed",
            top: "10px",
            right: "10px",
            background: getSocketStatusColor(),
            color: textWhite,
            padding: "8px 16px",
            borderRadius: "4px",
            fontSize: "14px",
            zIndex: 9999,
            boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
          }}
        >
          {getSocketStatusText()}
        </div>
      )}

      {/* Max Reconnect Reached Modal */}
      {maxReconnectReached && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0, 0, 0, 0.7)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 10000,
          }}
        >
          <div
            style={{
              background: textWhite,
              padding: "30px",
              borderRadius: "8px",
              maxWidth: "400px",
              textAlign: "center",
              boxShadow: "0 4px 6px rgba(0,0,0,0.3)",
            }}
          >
            <div style={{ marginBottom: "20px" }}>
              <Warning color={danger} width="48" height="48" />
            </div>
            <h3 style={{ color: textDark, marginBottom: "15px" }}>Koneksi Terputus</h3>
            <p
              style={{
                color: textDark,
                marginBottom: "25px",
                lineHeight: "1.5",
              }}
            >
              Koneksi ke server telah terputus setelah {MAX_RECONNECT_ATTEMPTS} kali percobaan. Silakan refresh halaman
              untuk mencoba kembali.
            </p>
            <Button
              variant="primary"
              onClick={handleRefreshPage}
              style={{
                padding: "10px 30px",
                fontSize: "16px",
                fontWeight: "500",
              }}
            >
              Refresh Halaman
            </Button>
          </div>
        </div>
      )}

      {liveAuction === "STARTED" ? (
        <>
          {isReady ? (
            <>
              <div className="page h-100 pb-3">
                <Container>
                  <Row>
                    <Col md={5}>
                      <div className="box-border mt-15">
                        <div className="unit-slider w-100">
                          <CarouselLayout className="dots-left" dots={true} adaptiveHeight={true}>
                            {images.length > 0 ? (
                              images.slice(0, 5).map((image, i) => (
                                <div key={"img" + i}>
                                  <img
                                    className="with-background detail-unit-slider"
                                    src={image.image_url || image.image}
                                    alt={`Unit preview ${i + 1}`}
                                    style={{
                                      height: "auto",
                                      width: "100%",
                                      display: "block",
                                    }}
                                    onError={(e) => {
                                      e.target.src = defaultImage;
                                    }}
                                  />
                                </div>
                              ))
                            ) : (
                              <div style={{ height: "222px" }}>
                                <div
                                  className="with-background detail-unit-slider"
                                  style={{
                                    background: defaultImage ? `url(${defaultImage})` : "",
                                    height: "100%",
                                    width: "100%",
                                    objectFit: "contain",
                                    minHeight: 200,
                                  }}
                                ></div>
                              </div>
                            )}
                          </CarouselLayout>

                          <div className="grade-desktop d-none d-md-block  ">
                            {data?.unit_inspection?.grade && (
                              <p className="nomor-lot ">
                                Grade
                                <span>{data?.unit_inspection?.grade}</span>
                              </p>
                            )}
                          </div>
                          {/* mobile view */}
                          <div className="d-block d-md-none position-absolute top-0 end-0">
                            <div className="badge-lot">
                              <span className="nomor-lot me-2">
                                Lot{" "}
                                {auction?.auction_lane_name && data?.lot_number
                                  ? auction?.auction_lane_name + data?.lot_number
                                  : "-"}
                              </span>
                              <span className="nomor-lot">Grade {data?.unit_inspection?.grade || "-"}</span>

                              {data?.number_of_nipl > 1 && (
                                <span className="nomor-lot nipl">
                                  <span className="icon-nipl">
                                    <SpecialNIPL />
                                  </span>
                                  Special NIPL
                                </span>
                              )}
                            </div>
                          </div>

                          {/* desktop view */}
                          <div className="grade-unit-auction d-none d-md-absolute">
                            Grade
                            <br />
                            <span className="grade-auction">{data?.unit_inspection?.grade || "-"}</span>
                          </div>
                        </div>
                        <div className="d-none d-md-block">
                          <h2 className="unit-name-auction">{data?.unit_name || ""}</h2>
                          <span className="unit-title">Highlight</span>
                          <div className="unit-highlight">
                            {data?.tags?.length > 0
                              ? data?.tags.map((row, i) => <span key={"tag" + i}>{row.name}</span>)
                              : "-"}
                          </div>

                          <span className="unit-title">Detail Kendaraan</span>
                          <div className="bidder-data">
                            <UnitInformation
                              informations={data?.stock_informations}
                              documents={data?.stock_documents}
                            />
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col md={7}>
                      <div className="mt-18">
                        <div className="d-none d-md-block">
                          <div className="badge-lot">
                            <span className="nomor-lot">
                              Lot{" "}
                              {auction?.auction_lane_name && data?.lot_number
                                ? auction?.auction_lane_name + data?.lot_number
                                : "-"}
                            </span>
                            {data.number_of_nipl > 1 && (
                              <span className="nomor-lot nipl">
                                <span className="icon-nipl">
                                  <SpecialNIPL />
                                </span>
                                Special NIPL
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-between">
                          <span className="unit-title">Harga Dasar</span>
                          <span className="d-inline d-md-none unit-title">Bidder</span>
                        </div>
                        <div className="group">
                          <span className="unit-price" style={{ flex: "1" }}>
                            Rp {data?.base_price !== undefined ? data?.base_price?.toLocaleString() : "0"}
                          </span>
                          <span
                            className="count-customer"
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "6px",
                              padding: "6px 12px",
                              backgroundColor: "#f0f4f8",
                              borderRadius: "20px",
                              fontSize: "16px",
                              fontWeight: "500",
                              color: "#374151",
                              border: "1px solid #e5e7eb",
                            }}
                          >
                            <UserIcon style={{ width: "16px", height: "16px" }} />
                            <span>{totalNipl || 0} Orang</span>
                          </span>
                        </div>

                        <div className="bidder-list" style={{ marginTop: "20px" }}>
                          <div className="header flex-column flex-md-row">
                            <span className="title" style={{ textAlign: "left" }}>
                              Harga Penawaran Saat Ini
                            </span>
                            <span className="timer text-center">
                              <TimerIcon />
                              {secondsToTime(counter)}
                            </span>
                          </div>
                          <ResponsiveBidderDisplay highestBid={highestBid} thisUser={thisUser} />
                          <div className="bidder-data d-none d-md-block">
                            {biddingList?.length > 0
                              ? biddingList
                                  ?.filter((bid) => bid?.offer_price !== highestBid?.offer_price)
                                  ?.map((bid, index) => {
                                    const bidderName = getBidderDisplayName(bid, thisUser);
                                    return (
                                      <div
                                        className={`bidder-item ${
                                          getBidderDisplayName(bid, thisUser) === "Saya" && "active"
                                        }`}
                                        key={`bid-${index}`}
                                      >
                                        <span className="bid-value">Rp {bid?.offer_price?.toLocaleString()}</span>
                                        <span className="bidder">{bidderName}</span>
                                      </div>
                                    );
                                  })
                              : (highestBid?.type === "Harga Dasar" || highestBid?.email === "base_price") && (
                                  <div className="bidder-item text-center font-sm text-secondary">
                                    <span className="mx-auto">Belum ada yang melakukan penawaran</span>
                                  </div>
                                )}
                          </div>
                        </div>
                        <div
                          className={`box-border proxy-bid ${
                            proxyList.filter((v) => !v.is_cancelled).length > 0 ? "d-block" : "d-none"
                          }`}
                          style={{ marginTop: "20px" }}
                        >
                          <span className="title-header">Proxy Bid</span>
                          {proxyList.filter((v) => !v.is_cancelled).length > 0
                            ? proxyList
                                .filter((v) => !v.is_cancelled)
                                .map((proxy, iddx) => (
                                  <div
                                    className="group"
                                    key={`proxy-${proxy.id || iddx}`}
                                    style={{ display: "flex", alignItems: "center" }}
                                  >
                                    <span
                                      style={{
                                        padding: "5px",
                                        background: "#F9E6E6",
                                        borderRadius: "50%",
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <ProxyBidIcon />
                                    </span>
                                    <span className="no-nipl" style={{ flex: "1" }}>
                                      {proxy?.nipl?.nipl ? `NIPL: ${proxy.nipl.nipl}` : "-"}
                                    </span>
                                    <span className="bidder" style={{ flex: "1", textAlign: "right" }}>
                                      Rp {parseInt(proxy?.offer_price).toLocaleString()}
                                    </span>
                                  </div>
                                ))
                            : ""}
                        </div>

                        <div
                          className="d-none d-md-block box-border form-bid"
                          style={{ marginTop: "20px", overflow: "hidden" }}
                        >
                          {SpecialNIPLToggle &&
                            ((data?.number_of_nipl > 1 &&
                              SpecialNIPLToggle?.remaining_nipls < data?.number_of_nipl &&
                              SpecialNIPLToggle?.used_nipls_this_stock_unit === 0) ||
                              (SpecialNIPLToggle?.remaining_nipls === 0 && data?.number_of_nipl === 1)) && (
                              <div className="alert-nipl">
                                <Warning color="#FF4D4D" /> Jumlah NIPL Anda tidak cukup untuk melakukan penawaran
                              </div>
                            )}
                          <div className="d-flex tw-justify-between m-2">
                            <span className="title-header">Tawar</span>
                            <div className="coupon-header d-flex">
                              <Coupon />
                              <p className="m-0">
                                NIPL anda: <span>{SpecialNIPLToggle.remaining_nipls || 0}</span>
                              </p>
                            </div>
                          </div>
                          <div className="group">
                            <div style={{ flex: "1" }}>
                              <InputGroup>
                                <InputGroup.Text id="basic-addon1">Rp</InputGroup.Text>
                                <CurrencyInput
                                  id="hargaTawar"
                                  name="offer"
                                  className="form-control"
                                  placeholder="Masukan penawaran"
                                  disabled={disableBid === "off" || blockBid === "on"}
                                  value={offer}
                                  prefix="Rp "
                                  groupSeparator=","
                                  decimalSeparator="."
                                  readOnly
                                  allowDecimals={false}
                                  onValueChange={(value, name) => changeOffer(value)}
                                />
                              </InputGroup>
                              <small className="text-primary">{error}</small>
                            </div>
                          </div>
                          <div className="group flex-center tes" style={{ marginTop: "10px" }}>
                            <div
                              className="d-flex"
                              style={{
                                flexWrap: "wrap",
                                alignItems: "center",
                                textAlign: "left",
                                justifyContent: "space-between",
                                maxWidth: "530px",
                                width: "100%",
                              }}
                            >
                              <div className="d-none d-md-flex align-items-center justify-content-center gap-1 px-3">
                                <Form.Check
                                  className="mx-1"
                                  type="switch"
                                  id="custom-switch"
                                  checked={disableBid === "on"}
                                  onClick={bidHandler}
                                  onChange={bidHandler}
                                />
                                {disableBid === "off" && (
                                  <div className="d-flex align-items-center gap-1">
                                    <LockOn active={disableBid} />
                                    <span className="font-sm" style={{ color: bidDisabledInactive }}>
                                      Nonaktif
                                    </span>
                                  </div>
                                )}
                                {disableBid === "on" && (
                                  <div className="d-flex align-items-center gap-1">
                                    <LockOff active={disableBid} />
                                    <span className="font-sm" style={{ color: bidDisabledActive }}>
                                      Aktif
                                    </span>
                                  </div>
                                )}
                              </div>
                              {data.number_of_nipl > 1 && (
                                <div className="coupon-footer d-flex" style={{ width: "170px", minWidth: "unset" }}>
                                  <Coupon />
                                  <p className="m-0">
                                    <span>{data.number_of_nipl} NIPL</span> untuk menawar
                                  </p>
                                </div>
                              )}
                            </div>
                            <ShadowClickButton
                              color={color}
                              setIsProcess={setIsProcess}
                              disableBid={disableBid}
                              disabled={disableBid === "off" || blockBid === "on" || isProcess === "on"}
                              isProcess={isProcess}
                              postBid={postBid}
                            />
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Container>

                {/* ini hanya tampil di mobile */}
                <Container className="d-block d-md-none">
                  <div className="box-lelang p-3" style={{ margin: "20px 0" }}>
                    <span className="unit-title mt-0">Highlight</span>
                    <div className="unit-highlight">
                      {data?.tags?.length > 0
                        ? data?.tags.map((row, i) => <span key={"tag" + i}>{row.name}</span>)
                        : "-"}
                    </div>

                    <span className="unit-title">Detail Kendaraan</span>
                    <UnitInformation informations={data?.stock_informations} documents={data?.stock_documents} />
                  </div>
                </Container>

                <Container>
                  <Row>
                    <Col md="12">
                      <div
                        className="box-lelang d-none d-md-block"
                        style={
                          auction?.unit_type?.banner_url
                            ? {
                                marginTop: "20px",
                                backgroundImage: `url(${auction?.unit_type?.banner_url})`,
                              }
                            : {
                                marginTop: "20px",
                                backgroundImage: `url(${imageCar})`,
                              }
                        }
                      >
                        <div className="group">
                          <div style={{ flex: "1", paddingLeft: "20px", paddingTop: "10px" }}>
                            <span className="lelang-title">{auction?.name || "-"}</span>
                            <div className="lelang-date" style={{ color: "#1E1E1F" }}>
                              {formatAuctionDate(auction?.date_start, auction?.time_start, "date")}
                            </div>
                          </div>
                          <div style={{ flex: "1", paddingLeft: "20px", paddingTop: "10px" }}>
                            <div className="lelang-time">
                              <Time />{" "}
                              <span>
                                {formatAuctionTimeRange(auction?.date_start, auction?.time_start, auction?.time_finish)}
                              </span>
                            </div>
                            <div className="lelang-location">
                              <Location /> <span>{auction?.location_name || "-"}</span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="box-lelang d-flex d-md-none" style={{ marginTop: "20px" }}>
                        <div className="d-flex flex-column flex-md-column">
                          <div style={{ flex: "1", paddingLeft: "20px", paddingTop: "10px" }}>
                            <span className="lelang-title">{auction?.name || "-"}</span>
                            <div className="lelang-date" style={{ color: "#1E1E1F" }}>
                              {formatAuctionDate(auction?.date_start, auction?.time_start, "date")}
                            </div>
                          </div>
                          <div style={{ flex: "1", paddingLeft: "20px", paddingTop: "10px" }}>
                            <div className="lelang-time">
                              <Time />{" "}
                              <span>
                                {formatAuctionTimeRange(auction?.date_start, auction?.time_start, auction?.time_finish)}
                              </span>
                            </div>
                            <div className="lelang-location">
                              <Location /> <span>{auction?.location_name || "-"}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Container>

                <Container>
                  <div className="produk-terkait w-100">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h3>Lot Selanjutnya</h3>
                    </div>
                    <CarouselMultipleLayout
                      slideToShow={4}
                      totalItem={nextLots?.length || 0}
                      infinite={false}
                      restoreSlide={currentNextLotSlideRef.current}
                      afterChange={(currentSlide) => {
                        currentNextLotSlideRef.current = currentSlide;
                        const slidesToShow = 4;
                        const isAtEnd = currentSlide >= nextLots.length - slidesToShow;
                        if (isAtEnd && nextLotsPageRef.current < nextLotsTotalPage && !nextLotsLoading) {
                          fetchNextLots(nextLotsPageRef.current + 1, true);
                        }
                      }}
                    >
                      {nextLots?.length > 0 ? (
                        nextLots.map((item, idx) => (
                          <LazyLotCard
                            key={`lot-${item?.id || idx}`}
                            item={item}
                            auction={auction}
                            processUnitDetails={processUnitDetails}
                          />
                        ))
                      ) : (
                        <div className="col-md-12 text-center py-4">Tidak ada Lot selanjutnya</div>
                      )}
                    </CarouselMultipleLayout>
                  </div>
                </Container>

                {/* tampil saat mobile */}
                <div
                  className="d-block d-md-none position-fixed w-100 bottom-0 box-border form-bid"
                  style={{ marginTop: "20px", overflow: "hidden", zIndex: 10 }}
                >
                  {SpecialNIPLToggle &&
                    ((data?.number_of_nipl > 1 &&
                      SpecialNIPLToggle?.remaining_nipls < data?.number_of_nipl &&
                      SpecialNIPLToggle?.used_nipls_this_stock_unit === 0) ||
                      (SpecialNIPLToggle?.remaining_nipls === 0 && data?.number_of_nipl === 1)) && (
                      <div className="alert-nipl">
                        <Warning color={danger} /> Jumlah NIPL Anda tidak cukup untuk melakukan penawaran
                      </div>
                    )}
                  <div className="d-flex tw-justify-between m-2">
                    <span className="title-header">Tawar</span>{" "}
                    <div className="coupon-header d-flex">
                      <Coupon />
                      <p className="m-0">
                        NIPL anda: <span>{SpecialNIPLToggle.remaining_nipls}</span>
                      </p>
                    </div>
                  </div>
                  <div className="group">
                    <div style={{ flex: "1" }}>
                      <InputGroup>
                        <InputGroup.Text id="basic-addon1">Rp</InputGroup.Text>
                        <CurrencyInput
                          id="hargaTawar"
                          name="offer"
                          className="form-control"
                          placeholder="Masukan penawaran"
                          disabled={disableBid === "off" || blockBid === "on"}
                          value={offer}
                          prefix="Rp "
                          groupSeparator=","
                          decimalSeparator="."
                          readOnly
                          allowDecimals={false}
                          onValueChange={(value, name) => changeOffer(value)}
                        />
                      </InputGroup>
                      <small className="text-primary">{error}</small>
                    </div>
                  </div>
                  <div className="group align-items-center" style={{ marginTop: "10px" }}>
                    <div
                      className="d-flex"
                      style={{
                        flexWrap: "wrap",
                        alignItems: "center",
                        textAlign: "right",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <div className="d-flex align-items-center">
                        <Form.Check
                          className="ms-1 me-2"
                          type="switch"
                          id="custom-switch"
                          checked={disableBid === "on" ? true : false}
                          // value={disableBid}
                          onClick={bidHandler}
                          onChange={bidHandler}
                        />
                        <div className={`d-flex align-items-center ml-2`}>
                          {disableBid === "on" ? (
                            <>
                              {" "}
                              <LockOff active={disableBid} />
                              <span
                                className="font-sm ml-1 "
                                style={{
                                  color: disableBid === "on" ? "#2AB95E" : "",
                                }}
                              >
                                Aktif
                              </span>
                            </>
                          ) : (
                            <>
                              <LockOn active={disableBid} />
                              <span className="font-sm ml-1 " style={{ color: disableBid === "off" ? "#ff0000" : "" }}>
                                Nonaktif
                              </span>
                            </>
                          )}
                        </div>
                      </div>{" "}
                      {data.number_of_nipl > 1 && (
                        <div className="coupon-footer d-flex">
                          <Coupon />
                          <p className="m-0" style={{ borderRight: "none" }}>
                            <span>{data.number_of_nipl} NIPL</span> untuk menawar
                          </p>
                        </div>
                      )}
                    </div>
                    <ShadowClickButton
                      color={color}
                      setIsProcess={setIsProcess}
                      disableBid={disableBid}
                      disabled={disableBid === "off" || blockBid === "on" || isProcess === "on"}
                      isProcess={isProcess}
                      postBid={postBid}
                    />
                  </div>
                </div>
              </div>
            </>
          ) : (
            <OnlineAuctionSkeleton />
          )}
        </>
      ) : null}
      {liveAuction === "PENDING" || liveAuction === "COMING" || liveAuction === "CLOSED" ? (
        <ArtworkPending status={liveAuction} />
      ) : (
        ""
      )}
      {liveAuction === "NOT_FOUND" ? <PageNotFound></PageNotFound> : ""}

      {modalResult ? (
        <KonfirmasiMenangLelang
          continue={closeModal}
          checkout={handleCheckout}
          loading={transactionId?.loading}
          checkoutMessage={checkoutMessage}
          showFallback={showFallback}
          onFallbackClick={() => push(`/pengaturan/transaksi`)}
          data={modalWinner}
        />
      ) : (
        ""
      )}
      {showNextLotModal && currentUnit ? <ResultLelang status={result} dataAuction={currentUnit} isRegular /> : ""}
      {isOpen ? <ResultLelang status={result} dataAuction={dataModal?.data_unit} isRegular /> : ""}
      {isSelectingWinner ? <ResultLelang status="LOADING" dataAuction={dataModal?.data_unit} isRegular /> : ""}
      {cancelProxy.isOpenModal ? <CancelledProxy setCancelProxy={setCancelProxy} /> : ""}
    </>
  );
}

const ShadowClickButton = ({ disableBid, color, disabled, setIsProcess, isProcess, postBid }) => {
  const COOLDOWN_MS = 1500; // 1.5 seconds
  const cooldownIntervalRef = useRef(null);
  const shadowClickTimeoutRef = useRef(null);

  const [lastApiCall, setLastApiCall] = useState(null);
  const [cooldownRemaining, setCooldownRemaining] = useState(0);

  const updateCooldown = () => {
    if (!lastApiCall) return;

    const now = Date.now();
    const timeSinceLastCall = now - lastApiCall;
    const remaining = Math.max(0, COOLDOWN_MS - timeSinceLastCall);

    setCooldownRemaining(Math.ceil(remaining / 1000));

    if (remaining <= 0 && cooldownIntervalRef.current) {
      clearInterval(cooldownIntervalRef.current);
      cooldownIntervalRef.current = null;
    }
  };

  const startCooldownTimer = () => {
    if (cooldownIntervalRef.current) {
      clearInterval(cooldownIntervalRef.current);
    }

    cooldownIntervalRef.current = setInterval(updateCooldown, 100);
    updateCooldown();
  };

  const handleButtonClick = async () => {
    const now = Date.now();
    const canMakeApiCall = !lastApiCall || now - lastApiCall >= COOLDOWN_MS;

    if (!canMakeApiCall) {
      // Shadow click logic (no API call)
      setIsProcess("on");
      shadowClickTimeoutRef.current = setTimeout(() => {
        setIsProcess("off");
      }, 500);
      return;
    }

    try {
      setIsProcess("on");
      setLastApiCall(now);
      startCooldownTimer();
      await postBid();
    } catch (err) {
      // Error handling is done in postBid function
      // No need to log here as it might expose sensitive information
    } finally {
      setIsProcess("off");
    }
  };

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (cooldownIntervalRef.current) {
        clearInterval(cooldownIntervalRef.current);
      }
      if (shadowClickTimeoutRef.current) {
        clearTimeout(shadowClickTimeoutRef.current);
      }
    };
  }, []);

  return (
    <Button
      className={`${disableBid === "off" ? "bid-off" : "bid-on"}`}
      disabled={disabled}
      onClick={handleButtonClick}
      variant={color}
      style={{ width: "160px" }}
    >
      {isProcess === "on" ? <Spinner animation="border" /> : "Tawar"}
    </Button>
  );
};
